import React, { useState, useRef, useEffect } from 'react';
import { BarChart2 } from 'lucide-react';

const CHART_TYPES = [
  { key: 'Candlestick', label: 'Candles' },
  { key: 'Line', label: 'Line' },
  { key: 'Area', label: 'Area' },
  { key: 'Bar', label: 'Bars' },
];

const ChartTypeSelector = ({ chartType, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  return (
    <div ref={dropdownRef} style={{ position: 'relative' }}>
      <button 
        className="toolbar-dropdown-btn" 
        onClick={() => setIsOpen(!isOpen)}
        title="Chart Type"
      >
        <BarChart2 size={16} />
        <span>Chart Type</span>
      </button>

      {isOpen && (
        <div className="toolbar-dropdown-menu">
          {CHART_TYPES.map(({ key, label }) => (
            <div
              key={key}
              className={`dropdown-item ${chartType === key ? 'active' : ''}`}
              onClick={() => {
                onChange(key);
                setIsOpen(false);
              }}
            >
              {label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChartTypeSelector;
